/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Physical_Reward_TitleInputs */

const en_plan_physical_reward_title = /** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly Physical Reward`)
};

const es_plan_physical_reward_title = /** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensa Física Mensual`)
};

const fr_plan_physical_reward_title = /** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récompense physique mensuelle`)
};

const de_plan_physical_reward_title = /** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Physische Belohnung`)
};

const id_plan_physical_reward_title = /** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadiah Fisik Bulanan`)
};

/** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */
const ja_plan_physical_reward_title = en_plan_physical_reward_title;

/** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */
const zh_plan_physical_reward_title = en_plan_physical_reward_title;

/** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */
const ar_plan_physical_reward_title = en_plan_physical_reward_title;

/** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */
const it_plan_physical_reward_title = en_plan_physical_reward_title;

/** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */
const ru_plan_physical_reward_title = en_plan_physical_reward_title;

/** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */
const pt_plan_physical_reward_title = en_plan_physical_reward_title;

/** @type {(inputs: Plan_Physical_Reward_TitleInputs) => LocalizedString} */
const ko_plan_physical_reward_title = en_plan_physical_reward_title;

/**
* | output |
* | --- |
* | "Monthly Physical Reward" |
*
* @param {Plan_Physical_Reward_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan_physical_reward_title = /** @type {((inputs?: Plan_Physical_Reward_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Physical_Reward_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan_physical_reward_title(inputs)
	if (locale === "es") return es_plan_physical_reward_title(inputs)
	if (locale === "fr") return fr_plan_physical_reward_title(inputs)
	if (locale === "de") return de_plan_physical_reward_title(inputs)
	if (locale === "ja") return ja_plan_physical_reward_title(inputs)
	if (locale === "zh") return zh_plan_physical_reward_title(inputs)
	if (locale === "ar") return ar_plan_physical_reward_title(inputs)
	if (locale === "id") return id_plan_physical_reward_title(inputs)
	if (locale === "it") return it_plan_physical_reward_title(inputs)
	if (locale === "ru") return ru_plan_physical_reward_title(inputs)
	if (locale === "pt") return pt_plan_physical_reward_title(inputs)
	return ko_plan_physical_reward_title(inputs)
});